import { render, staticRenderFns } from "./Eat.vue?vue&type=template&id=5265b0a1&"
import script from "./Eat.vue?vue&type=script&lang=js&"
export * from "./Eat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports